import React from "react";
import Tag from "@/shared/components/Tag/Tag";

export type SortConfig = {
  id: string
  label: React.ReactNode | string
  value: string
};

export type ActiveSortsProps = {
  sorts: SortConfig[]
  className?: string
  onRemoveSort?: (sortId: string) => void
  hidden?: boolean
};

export const ActiveSorts: React.FC<ActiveSortsProps> = ({
  sorts, className = "", onRemoveSort, hidden = false,
}) => {
  if (sorts.length === 0 || hidden) return null;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {sorts.map((sort) => (
        <Tag
          key={sort.id}
          type="sort"
          size="large"
          onRemove={onRemoveSort ? () => onRemoveSort(sort.id) : undefined}
        >
          {sort.label}
        </Tag>
      ))}
    </div>
  );
};
